const rawBase =
  process.env.REACT_APP_CONTROL_PLANE_URL ||
  "https://api.fids.eximenon.com";

// Ensure we always end up with .../api
const BASE = rawBase.endsWith("/api")
  ? rawBase
  : rawBase.replace(/\/$/, "") + "/api";

function getAuthToken() {
  try {
    const authData = localStorage.getItem('auth');
    if (authData) {
      const parsed = JSON.parse(authData);
      return parsed.token;
    }
  } catch (error) {
    console.error('Error reading auth token:', error);
  }
  return null;
}

export async function api(path, opts = {}) {
  const token = getAuthToken();
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "Authorization": `Bearer ${token}` } : {}),
      ...(opts.headers || {})
    },
    credentials: "include"
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${res.status} ${text}`);
  }

  const contentType = res.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    const text = await res.text();
    throw new Error(`Expected JSON, got: ${text.slice(0, 200)}`);
  }

  return res.json();
}
